/**
 * 分類マスターの一覧の行を、名前だけの一覧（`named-node-list.tsx`）の行の形へ写す。
 *
 * 作り直しの ID は number、名前だけの一覧が受ける ID は文字列である（`NamedNodeListItem`）。
 * 写しを画面ごとに書くと、アクターは `String(id)`・ドメインは `` `${id}` `` のように綴りが
 * 割れ、**同じ ID が画面によって別の文字列になる**。1 箇所に閉じる。
 *
 * 参照される数はここでは落とす。名前だけの一覧は行に名前しか出さない画面で、数を足すと
 * 1 行が 2 段になって「名前だけを縦に走査する」読み方ができなくなる。数は詳細が逆引きの
 * 件数として出す。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 分類マスターの一覧の行を、名前だけの一覧が受ける行の形へ写す。
 * @graph-connects none
 */
import type { MasterListItem, NamedNodeListItem } from '@cortex/domain-spec-console';

/**
 * 分類マスターの行を名前だけの一覧の行へ写す。
 *
 * 取得前（`undefined`）は空の並びにする。呼び出し側で `?? []` を書くと、書き忘れた画面だけが
 * 取得中に落ちる。
 *
 * @param items 分類マスターの一覧の行。取得前なら undefined
 * @returns 名前だけの一覧の行
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 分類マスターの一覧の行を名前だけの一覧の行へ写し、取得前は空の並びにする。
 * @graph-connects none
 */
export function toNamedNodeItems(
  items: readonly MasterListItem[] | undefined,
): readonly NamedNodeListItem[] {
  return (items ?? []).map((item) => ({
    nodeId: String(item.id),
    label: item.label,
    untranslated: item.untranslated,
  }));
}
